export const WEB_BACKTEST_RUN_ORIGINS = new Set(["starter_sample", "history", "strategy"]);

const STRING_PARAMETERS = new Set([
  "symbol", "timeframe", "strategy_mode", "strategy_source", "strategy_template_id",
  "ui_experience", "mode", "previous_mode", "source", "placement", "campaign", "locale", "slug",
  "duration_bucket", "error_category", "failure_stage", "status_bucket", "status", "catalog_version",
  "operational_status", "strategy_drift_status", "tab", "evidence_state", "account_state",
  "comparison_level", "objective", "format", "scope", "content_type", "entry_point", "sample_id",
]);
const NUMBER_PARAMETERS = new Set([
  "duration_ms", "trade_count", "net_profit_percentage", "tier_count", "entry_condition_count",
  "exit_condition_count", "warmup_candles", "accepted_candles", "observation_days", "max_candles",
  "minimum_trades", "result_count", "run_count", "workspace_run_count", "issue_count", "imported_count", "uploaded_count",
]);
const BOOLEAN_PARAMETERS = new Set([
  "retryable", "has_strategy_context", "reproducible_available", "configuration_attested",
  "signed_in", "partial_response", "baseline_saved", "minimum_trades_set", "uses_sample_rules",
]);

/** One final boundary keeps arbitrary fields/text out of the analytics transport. */
export function safeFunnelParameters(parameters: Record<string, unknown>): Record<string, string | number | boolean> {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(parameters)) {
    if (key === "run_origin") {
      if (typeof value === "string" && WEB_BACKTEST_RUN_ORIGINS.has(value)) result[key] = value;
    } else if (STRING_PARAMETERS.has(key) && typeof value === "string" && value.length <= 64) {
      const pattern = key === "symbol" ? /^[A-Z0-9][A-Z0-9=^./-]*$/ : /^[a-zA-Z0-9][a-zA-Z0-9_.+-]*$/;
      if (pattern.test(value)) result[key] = value;
    } else if (NUMBER_PARAMETERS.has(key) && typeof value === "number" && Number.isFinite(value)) {
      result[key] = value;
    } else if (BOOLEAN_PARAMETERS.has(key) && typeof value === "boolean") {
      result[key] = value;
    }
  }
  return result;
}
